import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-snackbar-component',
    templateUrl: './asda-snack-bar.component.html',
    imports: [MatIconModule],
})
export class AsdaSnackBarComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { icon: string; message: string }) {}
}
